import React from 'react'
import { useParams } from 'react-router-dom'
import CreateUserRoleBinding from '../../../components/CreateUserRoleBinding'
import { useApiRequest } from '../../../hooks'
import Spinner from '../../../components/Spinner'
import useGetUserData from '../../../hooks/useGetUserData'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const { id } = useParams()
  // const [user] = useApiRequest(`users/${id}`)
  const { user, loading } = useGetUserData(id);

  if (!user) {
    return <Spinner />
  }

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Assign a role</h1>}></ContextMenu>
      <CreateUserRoleBinding user={user} />
    </div>
  )
}
